const { default: useResource } = require('./useResource');

const useTimezones = () => {
	const {
		resources: timezones,
		findMany: findTimezones,
		isLoading
	} = useResource({
		url: '/api/v1/timezones',
		name: 'timezone'
	});

	return {
		timezones,
		findTimezones,
		isLoading
	};
};

export default useTimezones;
